<template>
  <div v-if="role === 'agent' || role === 'commercial'">

    <div class="row" >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Statistics for :</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <!--
                <div style="margin:auto;margin-top:-70px">

                <el-date-picker style="width:650px;margin:auto"
                                v-model="selected_month"
                                type= "daterange"
                                range-separator="To"
                                start-placeholder="Start month"
                                end-placeholder="End month">
                </el-date-picker>
                  -->

                <div class="col-md-2" style="margin-top:10px;">
                  <fg-input>
                    <el-date-picker v-model="selected_month[0]"
                                    type="date"
                                    placeholder="From"
                                    :picker-options="pickerOptions1">
                    </el-date-picker>
                  </fg-input>
                </div>
                <div class="col-md-2" style="margin-top:10px;">
                  <fg-input>
                    <el-date-picker v-model="selected_month[1]"
                                    type="date"
                                    placeholder="To"
                                    :picker-options="pickerOptions1">
                    </el-date-picker>
                  </fg-input>
                </div>
                <p-button style="margin-left:25px;" v-on:click="getStats()" type="success" round>Search</p-button>


            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Stats cards-->
    <div class="row" >
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">

          <div class="card-header">
            <div class="row">
              <div class="col-12">
                <h3>By supplier</h3>
                <download-csv :data="stats.suppliers"><a><i class="nc-icon nc-cloud-download-93" style="float:right;font-size:25px; color: #6bd098; cursor: pointer; margin:auto"></i></a></download-csv>
              </div>
            </div>
          </div>

          <div class="card-body table-responsive table-full-width" style="max-height:750px;overflow: auto;">
            <el-table :data="stats.suppliers" show-summary>
              <el-table-column label="Name" property="label" ></el-table-column>
              <el-table-column label="pending kb" property="pendingkb"></el-table-column>
              <el-table-column label="pending terminal" property="attenteterminal"></el-table-column>
              <el-table-column label="pending supplier" property="valide"></el-table-column>
              <el-table-column label="refused" property="refus"></el-table-column>
              <!--<el-table-column label="correction supplier" property="correctionfournisseur"></el-table-column>-->
              <el-table-column label="refused by supplier" property="refusfournisseur"></el-table-column>
              <el-table-column label="validated by supplier" property="validationfournisseur"></el-table-column>
              <el-table-column v-if="role === 'agent' && (login === 'arnaud.lothist@gmail.com' || login === 'mohammed')" label="com / pc €" property="pc"></el-table-column>
              <el-table-column v-if="role === 'agent' && (login === 'arnaud.lothist@gmail.com' || login === 'mohammed')" label="com tot. €" property="com"></el-table-column>

            </el-table>

          </div>
        </div>
      </div>

    </div>


    <div class="row" v-if="role === 'agent'">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">

          <div class="card-header">
            <div class="row">
              <div class="col-12">
                <h3>Validated by commercial</h3>
                <download-csv :data="stats.com"><a><i class="nc-icon nc-cloud-download-93" style="float:right;font-size:25px; color: #6bd098; cursor: pointer; margin:auto"></i></a></download-csv>
              </div>
            </div>
          </div>

          <div class="card-body table-responsive table-full-width" style="max-height:750px;overflow: auto;">
            <el-table :data="stats.com">
              <el-table-column label="Name" property="name" ></el-table-column>
              <el-table-column label="Monizze - Meal" property="MealMonizze"></el-table-column>
              <el-table-column label="Monizze - Eco" property="EcoMonizze"></el-table-column>
              <el-table-column label="Monizze - Gift" property="GiftMonizze"></el-table-column>
              <el-table-column label="Sodexo - Meal" property="MealSodexo"></el-table-column>
              <el-table-column label="Sodexo - Eco" property="EcoSodexo"></el-table-column>
              <el-table-column label="Pluxee - Meal" property="MealSodexoPluxee"></el-table-column>
              <el-table-column label="Pluxee - Eco" property="EcoSodexoPluxee"></el-table-column>
              <el-table-column label="Edenred - Meal" property="MealEdenred"></el-table-column>
              <el-table-column label="Edenred - Eco" property="EcoEdenred"></el-table-column>
              <el-table-column label="Edenred - Gift" property="GiftEdenred"></el-table-column>
              <!--<el-table-column label="Ems" property="Ems"></el-table-column>-->
              <el-table-column label="Connect" property="Connect"></el-table-column>
            </el-table>

          </div>
        </div>
      </div>

    </div>


  </div>
</template>
<script>
  import {DatePicker} from 'element-ui'
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard';
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
  import {Badge} from 'src/components/UIComponents'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
  import TaskList from './Widgets/TaskList'
  const WorldMap = () => ({
    component: import('./../Maps/WorldMap.vue'),
    loading: Loading,
    delay: 200
  })

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      StatsCard,
      ChartCard,
      CircleChartCard,
      WorldMap,
      Badge,
      TaskList
    },
    beforeMount() {
      this.routeUndesired(),
      this.getStats()
    },
    methods: {
      routeUndesired() {
        if(this.role != 'agent' && this.role != 'commercial') {
          this.$router.push({path: '/search/contracts'})
        }
      },
      getStats() {
        let tempDateFrom = new Date(this.selected_month[1])
        tempDateFrom.setDate(tempDateFrom.getDate() +1)
        tempDateFrom = tempDateFrom.toISOString()
        this.tots = {
          label: "TOTAL",
          pendingkb: 0,
          attenteterminal: 0,
          valide: 0,
          refus: 0,
          refusfournisseur: 0,
          validationfournisseur: 0,
          com: 0
        }


        this.$http({
          method: 'get',
          url: this.$apiUrl + '/contract/stats',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          params: [this.selected_month[0], tempDateFrom]
        }).then(response => (
          this.stats = response.data,
            this.stats.suppliers.forEach(el => {
              if(this.role === 'agent' && (this.login === 'arnaud.lothist@gmail.com' || this.login === 'mohammed')) {
                if(['ecoedenred','giftedenred', 'ecosodexo', 'mealsodexo', 'mealsodexopluxee', 'ecosodexopluxee'].indexOf(el.name.toLowerCase()) != -1) {
                  el.com = (el.validationfournisseur * 3.33).toFixed(2)
                  el.pc = 3.33
                  this.tots.com += (el.validationfournisseur * 3.33)//.toFixed(2)
                } else if(['ecomonizze','giftmonizze', 'mealmonizze'].indexOf(el.name.toLowerCase()) != -1) {
                  el.com = (el.validationfournisseur * 1.66).toFixed(2)
                  el.pc = 1.66
                  this.tots.com += (el.validationfournisseur * 1.66)//.toFixed(2)
                } else if(['mealedenred'].indexOf(el.name.toLowerCase()) != -1) {
                  el.com = (el.validationfournisseur * 6.66).toFixed(2)
                  el.pc = 6.66
                  this.tots.com += (el.validationfournisseur * 6.66)//.toFixed(2)
                } else {
                  el.com = 0
                  el.pc = 0
                  this.tots.com += 0
                }

                this.tots.pendingkb += el.pendingkb
                this.tots.attenteterminal += el.attenteterminal
                this.tots.valide += el.valide
                this.tots.refus += el.refus
                this.tots.refusfournisseur += el.refusfournisseur
                this.tots.validationfournisseur += el.validationfournisseur


              }
            }),
            this.tots.com = this.tots.com.toFixed(2) + "€"
            //this.stats.suppliers.push(this.tots)
          )
        ).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
    },
    data () {
      return {
        tots : {},
        login : localStorage.login,
        selected_month: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date(new Date().getFullYear(), new Date().getMonth() +1, 0)],
        role: localStorage.role,
        stats: []

      }
    }
  }

</script>
<style>

</style>
